import React, {useCallback, useEffect} from 'react';
import LFOTrackComponent from 'components/lfo/LFOTrackComponent.js';
import SamplerBrowser from "components/installation/SamplerBrowser.js"
import {WAVEFORM} from 'constants/arrangement-modes.js';
import DetailsView from 'components/DetailsView.js';
import {MIX_VIEW} from 'constants/view-modes.js';
import {SEQUENCER_VIEW} from 'constants/view-modes.js';
import AutomationToolbar from './AutomationToolbar.js';
import { connect } from "react-redux";
import {
    SOUNDS,
    EXTERNAL,
    SEQUENCES,
    PRESETS,
    INSTRUMENTS,
    NOTES} from 'constants/sidebar-view-modes.js';
import {setArrangementBottomResizing} from 'actions/index.js';
import {getEffectsComponent} from 'components/effects/getEffectsComponent.js';
import {PIANO_ROLL, EFFECTS} from 'constants/arrangement-modes.js';
import PianoRollComponent from 'components/pianoroll/PianoRollComponent.js';

function ArrangementBottomContainer(props) {
    let style = {
        height: props.bottomHeight
    };

    let {sequencerEngine} = props;

    const onMouseUp = useCallback(
        () => {
            props.setArrangementBottomResizing(false);
        },
        [props.setArrangementBottomResizing]);

    let content = '';
    let toolbar = '';
    if (props.hide) {
        return (
            <div></div>
        );
    }
    let track = undefined;
    if (props.selectedTrack !== undefined && props.sequencerEngine.tracks) {
        track = props.sequencerEngine.tracks[props.selectedTrack];

        if (track) {
            toolbar = (
                <AutomationToolbar track={track} sequencerEngine={props.sequencerEngine}/>
            );
        }
        if (props.bottomMode !== PIANO_ROLL) {
            content = (<SamplerBrowser bottomMode={props.bottomMode} track={track} sequencerEngine={sequencerEngine} id={props.id}/>);
        } else {
            if (track) {
                if (props.bottomHeight > 25) {
                    content = (
                        <PianoRollComponent
                          parentClassName="arrangement-bottom-container"
                          isLooping={false}
                          installation={true}
                          sequencerEngine={props.sequencerEngine}
                          hideToolbar={true}
                          track={track}
                        />);
                }
            }
        }
    } else {
        //style.height = 0;
    }

    return (
        <div
          onMouseUp={onMouseUp}
          style={style}
          className="arrangement-bottom-container">
          {toolbar}
          {content}
        </div>
    );
}

const mapStateToProps = (state, props) => {
    let id = props.sequencerEngine.engineId;
    let hide = false;
    if (state.sequencer.sidebarCollapsed) {
        hide = false;
    } else if (
        props.sequencerEngine.tracks && props.sequencerEngine.tracks.length === 0) {
        hide = true;
    }

    if (state.sequencer.viewMode !== SEQUENCER_VIEW) {
        // hide = true;
    }
 
    let track = props.sequencerEngine.tracks[state.mix.selectedTrack];
    if (track && track.tracks && track.tracks[0]) {
        track = track.tracks[0].track;
    }
    return {
        track: track,
        id: track === undefined ? 0 :
            track.sample !== undefined && track.sample.getId() !== undefined ?
            track.sample.getId() : track.presetName || track.getName(),
        numTracks: props.sequencerEngine.tracks && props.sequencerEngine.tracks.length,
        bottomHeight:   state.arrangement.bottomHeight,
        bottomMode: state.arrangement.bottomMode,
        selectedRows: state.arrangement.selectedRows,
        selectedTrack: state.mix.selectedTrack,
        hide: hide,
    };
};

const mapDispatchToProps = dispatch => {
    return {
        setArrangementBottomResizing: (resizing) =>
            dispatch(setArrangementBottomResizing(resizing)),
    };
};
 
export default connect(mapStateToProps, mapDispatchToProps)(ArrangementBottomContainer);
